import React from 'react';
import { IoMdClose } from 'react-icons/io';


interface Member {
    user: {
        name: string;
    };
    status: string;
}

interface MemberListProps {
    users: Member[];
    onClose: () => void;
}

const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.charAt(1).toUpperCase()
}

const MemberList: React.FC<MemberListProps> = ({ users, onClose }) => {
    return (
        <div className='participant-side'>
            <div className='members-title'>
                <p>
                    <strong>Member List</strong>
                </p>
                <IoMdClose onClick={onClose} className='icon' />
            </div>
            <ul>
                {users.map((user: Member, idx: number) => (
                    <li className={'list'} key={idx}>
                        <div className={'list'}>
                            <p className='name-circle'>{capitalizeFirstLetter(user.user.name)}</p>
                            <p>{user.user.name}</p>
                        </div>
                        <p>{user.status}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default MemberList;
